import gql from 'graphql-tag';
const createChef = gql`mutation createChef($chef: ChefInput!) {
    createChef(chef:$chef)
    }`
export default createChef

export const chefCancellationPolicy = gql`mutation chefCancellationPolicy($id: ID!, $cancelationPolicy: CancelationPolicyInput) {
    chefCancellationPolicy(id: $id, cancelationPolicy: $cancelationPolicy)
}`;
